export default {
  title: {
    jobPostingChannelAccountManagement: '招聘网站账号管理',
    jobPostingChannelAccountAdd: '添加',
    jobPostingChannelAccountEdit: '编辑'
  },
  menu: '招聘网站账号管理',
  label: {
    channelName: '招聘网站',
    job51MemberName: '会员名',
    username: '用户名',
    password: '密码',
    status: '状态',
    authorizedUser: '分配给',
    isPublic: '是否公开',
    job51: '前程无忧',
    zhiLian: '智联招聘',
    liepin: '猎聘网',
    boss: 'BOSS直聘',
    lietou: '猎聘猎头',
    authorizeAll: '所有用户',
    customAuthorization: '自定义',
    all: '所有用户'
  },
  btn: {
    addAccount: '添加'
  },
  message: {
    deleteDialogTitle: '请确认删除{channel}的{username}账号。',
    deleteSuccess: '删除成功',
    noChannelAccount: '该渠道未绑定帐号,请至公司管理-招聘网站账号管理处绑定，联系您的菁客客户成功经理获取更多帮助。'
  },
  placeholder: {
    channelName: '请选择渠道',
    job51MemberName: '请输入会员名',
    username: '请输入帐号名称',
    password: '清输入帐号密码',
    authorizedUser: '请选择用户'
  }
}
